import { computed, makeObservable } from 'mobx';
import { FiltersStateStrategyType, FilterType } from 'src/domains/layouts/webview/components/filters/Filters.state';

interface PropsType {
    marketFiltersForView: Array<{ id: string; key: string; label: string }>;
    activeMarketFilter: string;
    setActiveFilter: (filter: string) => void;
}

export class AlternativeMarketFiltersState implements FiltersStateStrategyType {
    public constructor(private readonly props: PropsType) {
        makeObservable(this);
    }

    @computed public get filters(): FilterType[] {
        return this.props.marketFiltersForView;
    }

    public getActiveFilterId(): string | number | null {
        return this.props.activeMarketFilter;
    }

    public setActiveFilterId(id: string | number | null): void {
        if (id !== null && typeof id !== 'number') {
            this.props.setActiveFilter(id);
        } else {
            console.error('Selected filter can not be `null` or `number`');
        }
    }
}
